export default __webpack_public_path__ + "static/media/Course-Icons5.4f800400.svg";